// A NEW LIVE REVISION WHILE THE VIEWER IS OPEN (owner 2026-10-25: an export from the Models
// page must update the model view). Every publish - the Revit / Navisworks plugins, the
// publisher, and the Models page's heavy-worker export - ends in the same
// POST /model-versions/project/:id/register, which makes the new version 'live' (directly,
// or after the models-bucket check). The server pushes nothing to open pages, so an open
// viewer asks GET /model-versions/project/:id/current every minute while the tab is visible
// and offers a reload when the live revision is no longer the one it opened with. The next
// open always streams the new one (the manifest is served no-cache).
import React, { useEffect, useRef } from "react";
import { notification } from "antd";
import { url, tokenRef } from "api";

export const POLL_MS = 60 * 1000;

export async function liveRevision(projectId) {
  const r = await fetch(`${url}/model-versions/project/${encodeURIComponent(projectId)}/current`, {
    headers: { Authorization: `Bearer ${localStorage.getItem(tokenRef)}` },
  });
  if (!r.ok) return undefined;
  const out = await r.json().catch(() => ({}));
  return (out && out.current && out.current.exportVersion) || null;
}

export default function LiveRevisionWatch({ projectId, enabled = true, pollMs = POLL_MS }) {
  const seen = useRef(undefined);
  useEffect(() => {
    if (!projectId || !enabled) return undefined;
    seen.current = undefined;
    let alive = true;
    const check = async () => {
      if (typeof document !== "undefined" && document.hidden) return;
      let v;
      try {
        v = await liveRevision(projectId);
      } catch (e) {
        return;
      }
      if (!alive || v === undefined) return;
      if (seen.current === undefined) {
        seen.current = v;
        return;
      }
      if (v && v !== seen.current) {
        seen.current = v;
        const key = `live-revision-${projectId}`;
        notification.info({
          key,
          duration: 0,
          message: "A new revision of this model is live",
          description: `Revision ${v}. Reload to see it.`,
          btn: (
            <button className="header-btn text-white bg-bid border-bid px-3" data-testid="live-revision-reload" onClick={() => window.location.reload()}>
              Reload
            </button>
          ),
        });
      }
    };
    check();
    const t = setInterval(check, pollMs);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [projectId, enabled, pollMs]);
  return null;
}
